import { Component, OnInit } from '@angular/core';
import { CommonService } from 'app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { SickLeaveListService } from 'app/services/sick-leave-list.service';
import { NoEmpidService } from 'app/services/no-empid.service';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-no-empid',
  templateUrl: './no-empid.component.html',
  styleUrls: ['./no-empid.component.css'],
  animations: [
    // Each unique animation requires its own trigger. The first argument of the trigger function is the name
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated90', style({ transform: 'rotate(90deg)' })),
      state('rotated180', style({ transform: 'rotate(180deg)' })),
      state('rotated270', style({ transform: 'rotate(270deg)' })),
      state('rotated360', style({ transform: 'rotate(360deg)' })),
      transition('default => rotated90', animate('200ms ease-out')),
      transition('rotated90 => rotated180', animate('200ms ease-out')),
      transition('rotated180 => rotated270', animate('200ms ease-out')),
      transition('rotated270 => rotated360', animate('200ms ease-out')),

    ])
  ]
})
export class NoEmpidComponent implements OnInit {

  constructor(private commonService: CommonService,
    private _sanitizer: DomSanitizer,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public sickLeaveListService: SickLeaveListService,
    public noEmpidservice: NoEmpidService
  ) { }

  public rotateDegree = 0;
  public rotateDegreeString = '0';

  public dataObject = {
    "revisionkey": -1,
    "absenceid": "",
    "empid": "",
    "certificateid": "",
    "ocrcertdate": null,
    "ocrenddate": null,
    "ocrstartdate": null,
    "statusanalytics": -1,
    "statusanalytics_desc": "",
    "statushradmin": -1,
    "statushradmin_desc": ""
  };
  public certificateEnableFlag;
  public certificateErrorFlag;
  public certificateViewError;
  public certificateViewErrorFlag;
  public certificateError = '';
  public certificateData;
  public certificateViewData;

  ngOnInit() {
    this.certificateEnableFlag = false;
    this.certificateErrorFlag = false;
    this.dataObject = JSON.parse(localStorage.getItem('certAddon'));
    if (this.dataObject === null) {
      this.router.navigate(['/nel']);
    }
    const certificateID = this.dataObject.certificateid;
    this.getCertificate(certificateID, 'main');
  }

  getCertificate(certificateId, type) {
    if (type === 'main') {
      // this.certificateErrorFlag = false;
      this.certificateError = '';
    }
    if (type === 'other') {
      this.certificateViewErrorFlag = false;
      this.certificateViewError = '';
    }
    this.commonService.getCertificate(certificateId)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            if (type === 'main') {
              this.certificateViewErrorFlag = true;
              this.certificateData = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + res.response.base64image);
            }
            if (type === 'other') {
              this.certificateViewErrorFlag = true;
              this.certificateViewData = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + res.response.base64image);
            }
          }
          else {
            if (res.status === 'fail') {
              if (type === 'main') {
                this.certificateErrorFlag = true;
                this.certificateError = 'Unable to get the certificate!';
              }
              if (type === 'other') {
                this.certificateViewErrorFlag = true;
                this.certificateViewError = 'Unable to get the certificate!';
              }
            }
          }
        }, (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          if (type === 'main') {
            this.certificateErrorFlag = true;
            this.certificateError = 'Unable to get the certificate!';
          }
          if (type === 'other') {
            this.certificateViewErrorFlag = true;
            this.certificateViewError = 'Unable to get the certificate!';
          }
        });
  }

  getIssuesIntoArray(list) {
    let tempArray = [];
    let splitedArray = []
    splitedArray = list.split(';');
    for (let i = 0; i < splitedArray.length; i++) {
      if (splitedArray[i].trim() !== '') {
        tempArray.push(splitedArray[i]);
      }
    }
    return tempArray;
  }

  matchEmpID(empid) {
    if (empid !== null && empid.trim() !== '') {
      this.noEmpidservice.updateEmpidForCert(this.activatedRoute.snapshot.paramMap.get('certificateID'), 'empid', empid, '')
        .subscribe(
          (res) => {
            if (res.status === 'success') {
              alert('Employee ID updated with Certificate successfully!');
              this.router.navigate(['/nel']);
            } else {
              if (res.status === 'fail') {
                alert('Error while updating the employee ID with Certificate!');
              }
            }
          },
          (err) => {
            if (err.status === 401) {
              alert('You are either unauthorized or your seesion is expired!');
              this.sickLeaveListService.redirectToSAB();
            }
            alert('Error while updating the employee ID with Certificate!');
          });
    } else {
      alert('Please enter the Employee ID!');
    }
  }

  changeStauts(statuscode) {
    this.noEmpidservice.updateEmpidForCert(this.dataObject.certificateid, 'statuscode', '', statuscode)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            alert('Status changed successfully!');
            this.router.navigate(['/nel']);
          } else {
            alert('Error while updating the status!');
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          alert('Error while updating the status!');
        }
      );
  }
  state: string = 'default';

  rotate() {
    //this.state = (this.state === 'default' ? 'rotated' : 'default');
    if (this.state === 'default') {
      this.state = 'rotated90'
    } else if (this.state === 'rotated90') {
      this.state = 'rotated180'
    } else if (this.state === 'rotated180') {
      this.state = 'rotated270'
    } else if (this.state === 'rotated270') {
      this.state = 'rotated360'
      this.state = 'default';
    } else {
      this.state = 'default'
    }
  }

  rotateStyle: string;
  rotateImage() {
    this.rotateStyle = 'rotate';
    this.rotateDegree += 90;
    if (this.rotateDegree === 360) {
      this.rotateDegree = 0;
    }
    this.rotateDegreeString = this.rotateDegree.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/no-empid/no-empid.component.ts